import { obterLock } from '@/services/correcaoService';
import { ref } from 'vue';

// Trabalhos cujo aviso a pessoa já viu no card e escolheu abrir para leitura.
// O editor consome a marca para não repetir a mesma janela logo na entrada.
const avisosVistosNoCard = new Set<number>();

/** Retorna se o aviso já foi visto no card, e apaga a marca (uso único). */
export function consumirAvisoVistoNoCard(trabalhoId: number): boolean {
  return avisosVistosNoCard.delete(trabalhoId);
}

/**
 * Antes de abrir o editor a partir de um card, consulta (sem reservar) se outra
 * pessoa está editando o trabalho. Se estiver, mostra o aviso com o nome e só
 * abre se a pessoa escolher abrir para leitura. Quem entra pelo link direto
 * recebe o mesmo aviso dentro do próprio editor.
 */
export function useConferirTrabalhoEmUso(usuarioId: () => number | undefined) {
  const dialogVisivel = ref(false);
  const editandoPor = ref<string | null>(null);
  const conferindo = ref(false);
  let abrirPendente: (() => void) | null = null;
  let trabalhoPendente: number | null = null;

  const abrirConferindo = async (
    trabalhoId: number,
    abrir: () => void,
  ): Promise<void> => {
    conferindo.value = true;
    try {
      const lock = await obterLock(trabalhoId);
      // `?.user_id`, não só `lock`: sem reserva a API já respondeu `{}`, que é
      // truthy e abria a janela de "outra pessoa" a todo clique.
      if (lock?.user_id && lock.user_id !== usuarioId()) {
        editandoPor.value = lock.editando_por ?? null;
        abrirPendente = abrir;
        trabalhoPendente = trabalhoId;
        dialogVisivel.value = true;
        return;
      }
    } catch {
      // A consulta é só um aviso: se falhar, o editor confere de novo ao abrir.
    } finally {
      conferindo.value = false;
    }
    abrir();
  };

  const abrirMesmoAssim = (): void => {
    if (!dialogVisivel.value || !abrirPendente) return;
    const abrir = abrirPendente;
    abrirPendente = null;
    if (trabalhoPendente !== null) avisosVistosNoCard.add(trabalhoPendente);
    trabalhoPendente = null;
    dialogVisivel.value = false;
    abrir();
  };

  return {
    dialogVisivel,
    editandoPor,
    conferindo,
    abrirConferindo,
    abrirMesmoAssim,
  };
}
